import { useMemo } from 'react'
import { IAutomationObject } from '../../automationObjects';
// api
import { useGetObjectsChildrenQuery } from '../../services/objects';

interface useGetObjectsChildrenOutput {
    count: number,
    children: any[] | undefined,
    error: any,
    isLoading: boolean,
    isSuccess: boolean,
    isFetching: boolean,
    refetch: any
}


function useGetObjectsChildren(resourceGroupId: string, parentId: string, skip: boolean = false): useGetObjectsChildrenOutput {

    const hasId = (parentId !== undefined) && (parentId !== '');

    const { data, error, isLoading, isSuccess, currentData, refetch, isFetching } = useGetObjectsChildrenQuery({resourceGroupId,id: parentId},{ skip: !hasId || skip }) ;

    const items = useMemo(() => {
        if (data) {
            return [...data].sort((a: IAutomationObject, b: IAutomationObject) => a.description > b.description ? 1 : -1);
        } else if (currentData) {
            return [...currentData].sort((a: IAutomationObject, b: IAutomationObject) => a.description > b.description ? 1 : -1);
        }
    }, [data]);


    return {
        count: items?.length || 0,
        children: items,
        error: error,
        isLoading: isLoading && !items,
        isSuccess: isSuccess || (items !== undefined),
        isFetching: isFetching,
        refetch: refetch
    }
}

export default useGetObjectsChildren